export default __webpack_public_path__ + "static/media/dreamstime_s_83560464.a8a040d1.jpg";